import { FC } from "react";
import Modal from "react-modal";

import ModalContent from "./ModalContent";
import { IModalProps } from "./types";
import { contentStyle, overlayStyle } from "./styles";

import "./styles.scss";

const UIModal: FC<IModalProps> = (props) => {
  const {
    className,
    isOpen,
    onClose,
    canClose = true,
    shouldCloseOnOverlayClick = true,
    showCloseButton = true,
    customContentStyle,
    customOverlayStyle,
  } = props;

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={() => {
        onClose && onClose();
      }}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick && canClose}
      style={{
        content: Object.assign(contentStyle, customContentStyle || {}),
        overlay: Object.assign(overlayStyle, customOverlayStyle || {}),
      }}
      className={className || ""}
    >
      <ModalContent {...props} showCloseButton={showCloseButton} />
    </Modal>
  );
};

export default UIModal;
